import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../client';

export type PlanKey =
  | 'basic_monthly'
  | 'basic_annual'
  | 'pro_monthly'
  | 'pro_annual'
  | 'topup_500'
  | 'topup_2k'
  | 'topup_10k';

export interface BillingStatus {
  plan: string;                              // raw DB value ('free' | 'pro' | ...)
  effective_plan: string;                    // post-grace-period resolution
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  plan_expires_at: number | null;            // unix epoch, set during grace
  checkout_configured: boolean;
  customer_portal_available: boolean;
  // Per-plan_key availability — true iff the backend has the Stripe price ID
  // configured for that plan. UI hides CTAs for plans that would 503 on checkout.
  available_plans?: Partial<Record<PlanKey, boolean>> | null;
}

export function useBillingStatus() {
  return useQuery({
    queryKey: ['billing-status'],
    queryFn: () => apiFetch<BillingStatus>('/api/billing/status'),
  });
}
